import CloseIcon from "@mui/icons-material/Close";
import { DialogContent, IconButton, Typography } from "@mui/material";
import ChangePass from "../../commons/setPassword/setPassword";
import { StyledChangePassword } from "../../styled/changePassword";
import { StyledDialog } from "../../styled/dialog";
import CustomDialog from "../dialog/customDialog";

const ChangePasswordDialog = ({ open, onClose }) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs">
      <StyledDialog.MuiDialogTitle disableTypography>
        <StyledDialog.Title>Cambiar contraseña</StyledDialog.Title>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </StyledDialog.MuiDialogTitle>
      <DialogContent dividers>
        <StyledChangePassword.DialogContent
          id="alert-dialog-description"
          align="justify">
          <StyledChangePassword.Container>
            <Typography sx={{ marginBottom: 2 }}>
              A continuación, ingrese su <b>contraseña actual</b> y luego,
              repita su <b>nueva contraseña</b> dos veces.
            </Typography>
            <StyledChangePassword.Fields>
              <ChangePass type="ChangePassword" handleClose={onClose} />
            </StyledChangePassword.Fields>
            <Typography sx={{ fontSize: "small" }}>
              Las nuevas credenciales tendrán efecto en el siguiente inicio de
              sesión.
            </Typography>
          </StyledChangePassword.Container>
        </StyledChangePassword.DialogContent>
      </DialogContent>
    </CustomDialog>
  );
};

export default ChangePasswordDialog;
